import React from "react";
import isArray from "lodash/isArray";
import moment from "moment";
import PropTypes from "prop-types";

import DateTime from "components/DateTime";
import TitledContainer, { StaticText } from "components/TitledContainer";

import styles from "forms/forms.css";

const DateField = ({ align, field, form, isEdit, isInput, label, onEdit }) => {
  const Container = isInput
    ? (props) => (
        <TitledContainer
          isEdit={isEdit}
          isEmpty={isArray(field.value) ? !field.value.length : !field.value}
          onEdit={onEdit}
          title={label}
          isEditable
          {...props}
        />
      )
    : (
        { children } // eslint-disable-line
      ) => <>{children}</>;

  return (
    <div className={styles.field}>
      <Container>
        {isInput && !isEdit && (
          <StaticText
            text={
              isArray(field.value)
                ? field.value.map((d) => moment(d).format("L")).join(", ")
                : moment(field.value).format("L")
            }
          />
        )}
        {(isEdit || !isInput) && (
          <DateTime
            align={align}
            date={isArray(field.value) ? undefined : field.value}
            dates={isArray(field.value) ? field.value : undefined}
            isInput={isInput}
            isRequired={form.errors[field.name] && !!form.submitCount}
            label={label}
            onSave={({ date }) => form.setFieldValue(field.name, date)}
            isTimeHidden
          />
        )}
      </Container>
    </div>
  );
};

DateField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    errors: PropTypes.object,
    submitCount: PropTypes.number,
  }),
  align: PropTypes.oneOf(["left", "right"]),
  isEdit: PropTypes.bool,
  label: PropTypes.string,
  onEdit: PropTypes.func,
  isInput: PropTypes.bool,
};

DateField.defaultProps = {
  align: "left",
  isEdit: true,
};

export default DateField;
